import { Modal } from 'antd'
import { ButtonProps } from 'antd/lib/button'
import { ButtonCP } from 'common/components/button/ButtonCP'
import { useScreenSize } from 'common/responsiveness/use-screen-size/UseScreenSize'
import React from 'react'
import styled from 'styled-components'
import { FlexCP } from 'common/components/flex/FlexCP'
import { TextCP } from 'common/components/text/TextCP'
import { SystemConfig } from 'config/SystemConfig'

type _AntPropsTP = {
    visible?: boolean,
    title?: string | JSX.Element,
    onOk?: () => void,
    onCancel?: () => void,
    okText?: string,
    cancelText?: string,
    width?: string | number,
    zIndex?: number,
    okButtonProps?: ButtonProps,
    destroyOnClose?: boolean,
    closable?: boolean,
}

type _CustomPropsTP = {
    onClose?: (okClicked: boolean) => void,
    disableOutsideClickClosing?: boolean,
    loading?: boolean,
    singleButton?: boolean,
    noFooter?: boolean,
    top?: number,
    height?: number,
    mask?: boolean,
}

interface IModalCPProps extends React.PropsWithChildren<_AntPropsTP & _CustomPropsTP> {}

/**
 * COMPONENTE: Modal.
 * NOTE: Nao adianta envolver este componente em 01 wrapper pq ele eh reenderizado 'por cima' de tudo.
 */
export function ModalCP(props: IModalCPProps): JSX.Element {

    const screenSize = useScreenSize()

    function onClose(okClicked: boolean): void {

        if (!!props.onClose)
            props.onClose(okClicked)

        if (okClicked && !!props.onOk)
            props.onOk()

        if (!okClicked && !!props.onCancel)
            props.onCancel()
    }

    function renderCustomFooter(): JSX.Element | undefined {

        if (!!props.noFooter) {
            return (
                <FlexCP justifyContent={'center'} alignItems={'center'}>
                    <TextCP text={SystemConfig.getInstance().appName}/>
                </FlexCP>
            )
        }

        if (!!props.singleButton) {
            return (
                <SingleButtonFooterWrapperSCP>
                    <ButtonCP
                        type={'primary'}
                        onClick={() => onClose(true)}
                        loading={props.loading}
                    >
                        {props.okText ?? 'Salvar'}
                    </ButtonCP>
                </SingleButtonFooterWrapperSCP>
            )
        }

        return undefined
    }

    return (
        <Modal
            title={props.title}
            visible={props.visible}
            onOk={() => onClose(true)}
            onCancel={() => onClose(false)}
            okText={props.okText ?? 'Salvar'}
            cancelText={props.cancelText ?? 'Cancelar'}
            width={props.width ?? 530}
            zIndex={props.zIndex}
            maskClosable={props.disableOutsideClickClosing !== true}
            mask={props.mask ?? true}
            destroyOnClose={props.destroyOnClose}
            okButtonProps={props.okButtonProps}
            confirmLoading={props.loading}
            footer={renderCustomFooter()}
            closable={props.closable !== false}
            style={{
                top: screenSize.smd ? 10 : props.top,
            }}
            bodyStyle={{
                height: props.height,
                overflow: !!props.height ? 'hidden' : undefined,
                paddingBottom: !!props.height ? 10 : undefined,
            }}
        >
            {props.children!}
        </Modal>
    )
}

const SingleButtonFooterWrapperSCP = styled.div`
    display: flex;
    justify-content: flex-end;
`
